'use client'

;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:offsoo-landing":true});}catch(e){}}();import { clsx } from 'clsx/lite'
import type { ComponentProps } from 'react'

import { useCalendly } from '@/components/integrations/calendly/calendly-provider'
import { useIntercom } from '@/components/integrations/intercom/intercom-provider'
import { Button } from '@/components/ui/button'

type ContactChatLinkProps = ComponentProps<'button'>

export function ContactChatLink({ className, children, onClick, ...props }: ContactChatLinkProps) {
  const { open } = useIntercom()

  return (
    <button
      type="button"
      className={clsx('cursor-pointer', className)}
      onClick={(event) => {
        onClick?.(event)
        open()
      }}
      {...props}
    >
      {children}
    </button>
  )
}

type ContactDemoButtonProps = {
  label: string
  color?: ComponentProps<typeof Button>['color']
  /** Renders as an accent link rather than a button — for use inside a card that already has one. */
  plain?: boolean
  /** Colour override for the plain variant, e.g. white where it sits on the wallpaper. */
  className?: string
  /** Stable slug of where this button lives, carried onto `demo_opened`. */
  location?: string
}

export function ContactDemoButton({
  label,
  color = 'light',
  plain,
  className,
  location = 'contact',
}: ContactDemoButtonProps) {
  const { open, warmup } = useCalendly()

  if (plain) {
    return (
      <button
        type="button"
        onClick={() => open({ location })}
        onPointerEnter={warmup}
        onFocus={warmup}
        className={clsx(
          'w-fit cursor-pointer text-sm font-semibold hover:underline',
          className ?? 'text-accent-deep dark:text-accent-bright',
        )}
      >
        {label}
      </button>
    )
  }

  return (
    <Button
      type="button"
      size="lg"
      color={color}
      className="cursor-pointer"
      onClick={() => open({ location })}
      onPointerEnter={warmup}
      onFocus={warmup}
    >
      {label}
    </Button>
  )
}
